import { useState } from "react";

import Api from '../../services/ContactoServices'
import { useForm } from "react-hook-form";

export const useContacto = () => {

    const [loading, setLoading] = useState(false);

    const { register, watch, setValue, handleSubmit, reset, formState: { errors } } = useForm();

    const guadrarFormulario = async (data) => {
        setLoading(true);

        const response = await Api.guardarFormContactenos(data);
        if (!response.success) {
            setLoading(false);
            return;
        }

        reset();
        setLoading(false);
    }

    return {
        state: {
            loading
        },
        form: { register, watch, setValue, handleSubmit, errors, reset },
        functions: {
            guadrarFormulario
        }
    };
}